module.exports = __webpack_public_path__ + "img/总电站数量.85339596.png";